export default {"src":"/_next/static/media/Candle-price-chart.0adfb997.svg","height":185,"width":534};